import transform from "lodash/transform"
import isObject from "lodash/isObject"
import isEmpty from "lodash/isEmpty"
import isArray from "lodash/isArray"

export function isValidObject(possibleObject: any) {
    try {
        const testObject = Object(possibleObject)
        return possibleObject === testObject
    } catch {
        return false
    }
}

export function getObjectKeysSafely(possibleObject: any): string[] | null {
    if (isValidObject(possibleObject)) {
        return Object.keys(possibleObject)
    } else {
        return null
    }
}

export function getObjectEntriesSafely(
    possibleObject: any
): [string, any][] | null {
    if (isValidObject(possibleObject)) {
        return Object.entries(possibleObject)
    } else {
        return null
    }
}

export function isEmptyObject(possibleObject: any) {
    const keys = getObjectKeysSafely(possibleObject)
    return !(keys !== null && keys.length > 0)
}

/**
 * Removes empty objects and arrays from an object
 *
 * @param obj An object to clean
 */
export function clean(obj: any) {
    function internalClean(el: any) {
        return transform(el, (result: any, value: any, key: string) => {
            const isCollection = isObject(value)
            const cleaned = isCollection ? internalClean(value) : value

            if (isCollection && isEmpty(cleaned)) return

            isArray(result) ? result.push(cleaned) : (result[key] = cleaned)
        })
    }

    return isObject(obj) ? internalClean(obj) : obj
}
